import { Injectable } from 'injection-js';

import { ScriptService } from './../services/script.service';

export interface ScriptOptions {
  output: string;
  dryRun: boolean;
}

@Injectable()
export class ScriptCommand {
  constructor(private scriptService: ScriptService) { }

  run(taskFlags: string[], options: ScriptOptions) {
    this.scriptService.generateScript(taskFlags, options);
  }
}
